import { observable, runInAction } from "mobx"

import { fetchGetLongInternships } from "~/api/long-internships/get"
import { LongInternship } from "~/entities/LongInternship"

export default class LongInternshipStore {
  @observable longInternships: Array<LongInternship> = []

  fetch = async (number?: number): Promise<LongInternship[]> => {
    const longInternships = await fetchGetLongInternships()
    const data = longInternships.data?.map((datum) => {
      return new LongInternship(datum as any)
    })
    runInAction(() => {
      this.longInternships = data
    })
    return number === undefined ? this.longInternships : this.longInternships.slice(0, number)
  }
}
